import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../store/hooks";
import {AuthService} from "../services/AuthService";

export default function useFrameConnect() {
    const navigate = useNavigate()
    const searchPage = useAppSelector(state => state.search.page)

    useEffect(() => {
        window.addEventListener('message', (event) => {
            const data = event.data
            const localToken = AuthService.getToken()
            if (data.type === 'token' && data.token && data.token !== localToken) {
                AuthService.saveToken(data.token)
                navigate('/')
            }
        })
    }, [])

    useEffect(() => {
        window.parent.postMessage({
            type: 'height',
            value: searchPage?.id ? 800 : 200
        }, process.env.REACT_APP_SITE_URL || '*')
    }, [searchPage])
}